import { FC } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { AddPartnersTable } from '../addPartnersTable'

import { IAddPartnersModalProps } from './models/addPartnersModalProps'

import styles from './AddPartnersModal.module.scss'

export const AddPartnersModal: FC<IAddPartnersModalProps> = ({
  fYear,
  globalPartnerId,
  onCheckedItemsSave,
  onModalClose,
  globalPartnerType,
}) => {
  return (
    <ModalDialog
      size={'xl'}
      show
      content={AddPartnersTable}
      classes={{
        overlay: styles.closeButtonCross,
      }}
      contentProps={{
        fYear,
        globalPartnerId,
        onCheckedItemsSave,
        globalPartnerType,
      }}
      onClose={onModalClose}
    />
  )
}
